<template>
  <div v-if="selectedLeads.length > 0">
    <div class="pa-2" style="border: 1px solid gray; border-radius: 0.5rem;">
      <label>
        # Leads seleccionados
        <span v-if="exportAll" class="mx-2 cyan--text">
          (
          {{
            filterLeadsSearchedSt
              ? leadsSearchedSt.length
              : leadsTableFooterSt.total
          }}
          )
        </span>
        <span v-else class="mx-2 blue--text subtitle-2">
          {{ selectedLeads.length }}
        </span>
      </label>
      <div class="my-2" style="display: flex; gap: 0.5rem;">
        <div>
          <v-checkbox
            class="my-0 pa-0"
            hide-details
            :label="
              `Todos (${
                filterLeadsSearchedSt
                  ? leadsSearchedSt.length
                  : leadsTableFooterSt.total
              })`
            "
            v-model="exportAll"
          />
        </div>
        <v-select
          class="select-export-fields"
          v-model="exportFields"
          :items="fields"
          :menu-props="{ maxHeight: '370' }"
          label="Campos a exportar"
          multiple
          small-chips
          append-outer-icon="mdi-clipboard-text-multiple-outline"
          hide-details
          :disabled="selectedLeads.length === 0"
        >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle">
              <v-list-item-action>
                <v-icon
                  :color="exportFields.length > 0 ? 'indigo darken-4' : ''"
                  >{{ icon }}</v-icon
                >
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Todos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text caption"
              >(+{{ exportFields.length - 1 }} otros)</span
            >
          </template>
          <div slot="append-outer" style="display: flex; gap: 0.25rem;">
            <v-icon
              color="secondary"
              @click="exportClipboard"
              :disabled="exportFields.length === 0 || exceedsClipboardLimit"
              :title="
                exceedsClipboardLimit
                  ? `No se puede copiar más de ${clipboardExportLimit} leads al portapapeles, usa Descargar Excel`
                  : 'Copiar para Excel'
              "
            >
              mdi-clipboard-text-multiple-outline
            </v-icon>
            <v-icon
              color="secondary"
              @click="downloadExcelFile"
              :disabled="exportFields.length === 0"
              title="Descargar Excel"
            >
              mdi-file-excel-outline
            </v-icon>
          </div>
        </v-select>
      </div>
    </div>

    <v-dialog v-model="dialogLoading" max-width="400">
      <v-card>
        <v-card-title class="body-1">
          Obteniendo todos los Leads.
        </v-card-title>
        <v-card-text
          >Se aplican los filtros seleccionados al momento de obtener todos los
          Leads.
        </v-card-text>
        <v-card-text class="text-center">
          <v-progress-circular :value="20" indeterminate></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSuccess" max-width="400">
      <v-card>
        <v-card-title class="body-1 green--text">
          Los Leads se han copiado.
        </v-card-title>
        <v-card-text
          >Puedes pegar los Leads que se copiaron al portapapeles en un archivo
          Excel o .xls presionando Ctrl + V o Command + V
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogSuccess = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
moment.locale("es-mx");
import { mapState } from "vuex";
import { exportLeads, exportLeadsFile } from "../../api/lead-api";
import { RINGOVER_REAL_ESTATE_GROUP_IDS } from "@/constants/integrations/ringover";

const CLIPBOARD_EXPORT_LIMIT = 10000000000;

export default {
  data() {
    return {
      dataExport: null,
      dialogLoading: false,
      dialogSuccess: false,
      exportAll: false,
      role: localStorage.getItem("user_role"),
      exportFields: [],
      baseFields: [
        "Fecha de registro",
        "Hora de registro",
        "Nombre",
        "Teléfono",
        "Correo",
        "Llegó por",
        "Presupuesto",
        "Moneda",
        "¿Cómo nos encontró?",
        "¿Cómo nos contactó?",
        //Nuevas columnas agregadas...
        "Campaña",
        "Segmentación",
        /*   "Anuncio",
                    
        }, */
        //Mas columnas agregadas en Septiembre 2022
        "Formulario",
        "Costo",
        "Ventas",
        "Ingresos",
        "Palabra Clave",
        "Anuncio",
        //Fin de las columnas agregadas...
        "Ubicación",
        "Probable",
        "Observaciones",
        "% Perfilación",
        "Broker asignado",
        "Tiempo de respuesta",
        "Broker Externo asignado",
        "Status",
        "Comentarios",
        "Motivo de descarte",
        "Idioma",
        "Perfilación",
        "Perfil App",
        "¿Agendado a Zoom?",
        "Campos personalizados",
        "Intentos de llamada",
        "Intentos de SMS",
        "Intentos de correo",
        "Intentos de WhatsApp"
      ]
    };
  },
  watch: {
    selectedLeads() {
      this.exportAll = false;
      this.dataExport = null;
    },
    exportAll() {
      this.dataExport = null;
    },
    exportFields: {
      handler() {
        this.dataExport = null;
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      selectedLeads: state => state.leads.selectedItems,
      filterLeadsSearchedSt: state => state.leads.filterLeadsSearched,
      leadsSearchedSt: state => state.leads.leadsSearched,
      filtersSelectedSt: state => state.leads.filter.filtersSelected,
      leadsTableFooterSt: state => state.leads.leadsTableFooter,
      realEstateGroupSt: state => state.realEstateGroup.realEstateGroup
    }),
    showRingoverTagField() {
      return RINGOVER_REAL_ESTATE_GROUP_IDS.includes(
        this.realEstateGroupSt?._id
      );
    },
    fields() {
      return this.showRingoverTagField
        ? [...this.baseFields, "Ringover tag"]
        : this.baseFields;
    },
    isAllItemsSelected() {
      return this.exportFields.length === this.fields.length;
    },
    isSomeItemsSelected() {
      return this.exportFields.length > 0 && !this.isAllItemsSelected;
    },
    icon() {
      if (this.isAllItemsSelected) return "mdi-close-box";
      if (this.isSomeItemsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    exportCount() {
      if (this.exportAll) {
        return this.filterLeadsSearchedSt
          ? this.leadsSearchedSt.length
          : this.leadsTableFooterSt.total;
      }
      return this.selectedLeads.length;
    },
    exceedsClipboardLimit() {
      return this.exportCount > CLIPBOARD_EXPORT_LIMIT;
    },
    clipboardExportLimit() {
      return CLIPBOARD_EXPORT_LIMIT;
    }
  },
  methods: {
    buildExportBody() {
      const body = {
        fields: this.exportFields,
        includePerfilApp: this.exportFields.includes("Perfil App"),
        includeCustomFields: this.exportFields.includes("Campos personalizados")
      };
      body.filter = this.filtersSelectedSt;
      if (!this.exportAll) {
        body.leadIds = this.selectedLeads.map(i => i._id);
      }
      return body;
    },
    async exportClipboard() {
      if (this.exceedsClipboardLimit) {
        this.$snotify.error(
          `No es posible copiar más de ${CLIPBOARD_EXPORT_LIMIT} leads al portapapeles (intentas exportar ${this.exportCount}). Usa "Descargar Excel" en su lugar.`,
          {
            timeout: 4000,
            showProgressBar: false
          }
        );
        return;
      }
      if (this.dataExport !== null) {
        this.updateClipboard(this.dataExport);
        return;
      }
      const body = this.buildExportBody();
      this.dialogLoading = true;
      try {
        this.dataExport = await exportLeads({ ...body, formatDate: true });
      } catch (error) {
        this.$snotify.error("Ah ocurrido un problema, inténtelo más tarde");
      }
      this.dialogLoading = false;
      this.updateClipboard(this.dataExport);
    },
    async downloadExcelFile() {
      const body = this.buildExportBody();
      this.dialogLoading = true;
      try {
        const { blob, disposition } = await exportLeadsFile({
          ...body,
          formatDate: true
        });
        this.triggerFileDownload(blob, disposition);
      } catch (error) {
        this.$snotify.error("Ah ocurrido un problema, inténtelo más tarde");
      }
      this.dialogLoading = false;
    },
    triggerFileDownload(blob, disposition) {
      const filenameMatch =
        disposition && disposition.match(/filename="?([^"]+)"?/);
      const filename = filenameMatch ? filenameMatch[1] : "leads.xlsx";
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    updateClipboard(newClip) {
      const self = this;
      if (!newClip) {
        return "";
      } else {
        navigator.clipboard.writeText(newClip).then(
          function() {
            /* clipboard successfully set */
            self.dialogSuccess = true;
            self.$snotify.info("Copiado al portapapeles", {
              timeout: 1000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false
            });
          },
          function() {
            /* clipboard write failed */
            self.$snotify.error(
              "Ah ocurrido un problema, inténtelo más tarde",
              {
                timeout: 1500,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: false
              }
            );
          }
        );
      }
    },
    toggle() {
      this.$nextTick(() => {
        if (this.isAllItemsSelected) {
          this.exportFields = [];
        } else {
          this.exportFields = this.fields;
        }
      });
    }
  },
  created() {
    if (this.role === "developer") {
      const removeItems = [2, 3, 5, 11, 13];
      this.exportFields = this.fields.filter(
        (itm, idx) => !removeItems.includes(idx)
      );
    }
  }
};
</script>
<style scoped>
.select-export-fields {
  width: 300px;
  max-width: 300px;
}
.select-export-fields.disabled i {
  color: gray !important;
  background-color: gray !important;
}
#no-background-hover::before {
  cursor: default !important;
  background-color: transparent !important;
}
</style>
